import { useMemo } from 'react'

import type { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'

import IconChevronRight from '@/assets/icons/icon-chevron-right.svg'
import IconPlus from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { DataTable } from '@/components/ui/table/data-table.tsx'
import { useIcon } from '@/modules/tasks/components/icons'
import type { List } from '@/modules/tasks/service/task-list-service'
import { AppRoutes } from '@/utils/constants'

const columns: ColumnDef<List>[] = [
  {
    id: 'title-full',
    accessorKey: 'name',
    header: 'Name',
    cell: function Cell({ row }) {
      const icon = useIcon(row.original.icon, row.original.color)

      return (
        <div className="flex items-center gap-2">
          {icon}
          <span>{row.original.name}</span>
        </div>
      )
    },
  },
  {
    id: 'actions',
    header: 'Action',
    cell: ({ row }) => (
      <Link to={AppRoutes.Tasks.ListDetails.asUrl(String(row.original.id))}>
        <span className="flex items-center gap-2 text-primary-500 text-sm font-medium text-right truncate">
          View {row.original.tasks?.length ?? 0} Tasks
          <IconChevronRight className="w-4 h-4 flex-shrink-0" />
        </span>
      </Link>
    ),
  },
]

export interface TaskListTableProps {
  lists: List[]
  onCreate?: () => void
}

export const TaskListTable = ({ lists, onCreate }: TaskListTableProps) => {
  const extra = useMemo(
    () => (
      <Button
        className="col-span-6 lg:col-span-3 gap-1"
        onClick={onCreate}
      >
        <IconPlus className="w-5 h-5 flex-shrink-0" />
        New List
      </Button>
    ),
    [onCreate],
  )

  return (
    <DataTable
      title="My Lists"
      extra={extra}
      columns={columns}
      data={lists}
    />
  )
}
